import { SVGProps } from 'react';

export const ClosedClockIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#000000';
	return (
		<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx='7' cy='7' r='6' stroke={color} />
			<path d='M7 4V7L9 9' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	);
};
